import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DateUtil } from "../../core/data/date-util";
import { SUCustomHttpHeaders } from "../../core/constants/custom-http-headers";

@Injectable()
export class DateSerializerInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.headers.has(SUCustomHttpHeaders.SerializeDatesHeader)) {
            return next.handle(req);
        }

        req = req.clone({
            headers: req.headers.delete(SUCustomHttpHeaders.SerializeDatesHeader)
        });

        if (req.body) {
            const normalizedBody = this.normalizeDates(req.body);
            req = req.clone({ body: normalizedBody });
        }

        return next.handle(req);
    }

    private normalizeDates(obj: any): any {
        if (obj instanceof Date) {
            return DateUtil.toUtcDateOnly(obj);
        }

        if (Array.isArray(obj)) {
            return obj.map(item => this.normalizeDates(item));
        }

        if (obj !== null && typeof obj === 'object') {
            const result: any = {};
            for (const key of Object.keys(obj)) {
                result[key] = this.normalizeDates(obj[key]);
            }
            return result;
        }

        return obj;
    }
}
